const $ = window.jQuery;
import _ from 'lodash';
import Mark from 'mark.js';

// const suggest_url =
//     'https://search-api.swiftype.com/api/v1/public/engines/suggest.json';
// const engine_key = '2_pRxPU2QYeuUQ3PN3SU';

const api_url = window.AAM_SEARCH_URL;

$(() => {
    const $body = $('html,body');
    const $form = $('#search-header-form');
    const $search_header = $('#search-header');
    const $autocomplete = $('#header-autocomplete-results');
    const $barrier = $('#autocomplete-barrier');
    const loading = `<div class="aam__loading"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>`;

    const label_key = {
        'blog-post': 'Blog Posts',
        collection: 'Collections',
        event: 'Events',
        exhibition: 'Exhibitions',
        page: 'Pages',
        press: 'Press Items',
        resource: 'Resources',
        tour: 'Tours',
    };

    let searching = false;

    $search_header.on(
        'keyup',
        _.debounce(() => {
            const q = $search_header.val().trim();

            if (!searching) {
                if (!q) {
                    $autocomplete.html('');
                    $body.removeClass('--search-active');
                    return;
                }

                $body.addClass('--search-active');
                searching = true;
                $autocomplete.html(loading);

                setTimeout(() => {
                    $.ajax({
                        url: `${api_url}?s=${q}`,
                        type: 'GET',
                        contentType: 'application/json; charset=UTF-8',
                        headers: { 'Content-Type': 'application/json' },
                        // data: { engine_key, q },
                        complete: () => {
                            searching = false;
                        },
                    }).done(res => {
                        const { hits } = res;
                        let results_html = ``;

                        let sorted = {};

                        hits.forEach(hit => {
                            if (!sorted[hit.doc_type]) {
                                sorted[hit.doc_type] = [hit];
                            } else {
                                sorted[hit.doc_type].push(hit);
                            }
                        });

                        _.each(sorted, (results, type) => {
                            if (results.length) {
                                let record_type_html = `<ul class="aam-autocomplete -padded--h">`;
                                record_type_html += `<li class="aam-autocomplete__title">${type +
                                    (type === 'Press' ? '' : 's')}</li>`;

                                _.each(results, result => {
                                    record_type_html += `<li class="aam-autocomplete__item">`;
                                    record_type_html += `<a class="aam-autocomplete__item-link" href="${
                                        result.url
                                    }">`;
                                    record_type_html += `${result.title}</a>`;
                                    record_type_html += `</li>`;
                                });

                                record_type_html += `</ul>`;
                                results_html += record_type_html;
                            }
                        });

                        // _.each(records, (results, record_type) => {
                        //     if (results.length) {
                        //         let record_type_html = `<ul class="aam-autocomplete -padded--h">`;
                        //         record_type_html += `<li class="aam-autocomplete__title">${
                        //             label_key[record_type]
                        //         }</li>`;

                        //         _.each(results, result => {
                        //             record_type_html += `<li class="aam-autocomplete__item">`;
                        //             record_type_html += `<a class="aam-autocomplete__item-link" href="${
                        //                 result.url
                        //             }">`;
                        //             record_type_html += `${result.title}</a>`;
                        //             record_type_html += `</li>`;
                        //         });

                        //         record_type_html += `</ul>`;
                        //         results_html += record_type_html;
                        //     }
                        // });

                        const button_text = `Show all results`;
                        results_html += `<a href="${window.AAM_MAIN_SITE ||
                            ''}/?s=${q}" class="aam-autocomplete__all button button--gold button--lg">${button_text}</a>`;

                        $autocomplete.html(results_html);
                        const instance = new Mark(
                            'a.aam-autocomplete__item-link',
                        );
                        instance.mark(q);

                        $('.aam-autocomplete__all').on('click', () =>
                            $form.submit(),
                        );
                    });
                }, 300);
            }
        }, 400),
    );

    $barrier.on('click', () => {
        $autocomplete.html('');
        $body.removeClass('--search-active');
    });
});
